import React, { Component } from 'react';
import '../adminDash.css';
import withNavigate from '../../Global_files/WithNavigate';
import { Link } from 'react-router-dom';
import SiteIcon from '../../assets/icons8-building-64.png';
import EditIcon from '../../assets/icons8-edit.png';
import DeleteIcon from '../../assets/icons8-trash-50.png';
import { post, get } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import Button from '@mui/material/Button';
import moment from 'moment-timezone';
import globalVariables from "../../custom_libraries/globalVariables";
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import DialogBox from '../DialogBox';


class SiteView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            site_list: [],
            searchInput: '',
            currentPage: 1,
            rowsPerPage: 9,
            editToggle: false,
            sitename: '',
            siteid: '',
            address: '',
            organisation_name: '',
            // timezone_list: '',
            // timezone: '',
            client_list:[],
            selected_Customers:[],
            error:false,
            warning:false,
            success:false,
            success1: false,
            error1: false,
            confirmDialog: {
                isOpen: false,
                title: '',
                subtitle: '',
            },
            user_type: ''
        };
    }

    async componentDidMount() {
        const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
        this.setState({user_type : storedUserType}); //get user type of logged in user to set the edit.delete permission of device
        this.getSitesList();
        this.getCustomerList();
       // const timezones = moment.tz.names();
       // this.setState({ timezone_list: timezones });
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.warning !== prevState.warning ||
            this.state.error !== prevState.error ||
            this.state.error1 !== prevState.error1 ||
            this.state.success !== prevState.success ||
            this.state.success1 !== prevState.success1
        ) {
            if (
                this.state.warning ||
                this.state.error ||
                this.state.error1 ||
                this.state.success ||
                this.state.success1
            ) {
                setTimeout(() => {
                    this.setState({
                        warning: false,
                        error: false,
                        success:false,
                        success1: false,
                        error1: false,
                    });
                }, 3000); // 3 second
            }
        }
    }

    getCustomerList = async () => {
        console.log("Fetching data from:", urls.GET_USERS);
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            let dealer_id = localStorage.getItem(globalVariables.USER_ID);
            console.log("--------dealer_id---------", dealer_id);

            let headers = {
                "content-type": "application/json",
                Authorization: `Bearer ${access_token}`
            };
            let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id);
            console.log("--------url---------", url);
            const response = await get(url, headers); // API call
            console.log("--------response---------", response);

            // Validate the response and extract results
            if (!response || !response.results || !Array.isArray(response.results)) {
                console.error("Invalid response or results:", response);
                this.setState({ client_list: [] });
                return;
            }

            this.setState({ client_list: response.results });
            console.log("user_list---------", this.state.client_list);
        } catch (error) {
            console.error("Error in getCustomerList:", error);
            this.setState({ client_list: [] });
        }
    };

    handleSelectionChange = (event) => {
        const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);

        // Find the selected customers from the client_list based on the selected user IDs
        const selectedUsers = this.state.client_list.filter(user => selectedOptions.includes(user.user_id));
        console.log("selected users",selectedUsers)
        // Update the selected_Customers state
        this.setState({ selected_Customers: selectedUsers });
    };

    getSitesList = async () => {
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }

            console.log("Fetching data from:", urls.GET_SITES_BY_USER); // Update URL for fetching sites
            const response = await get(urls.GET_SITES_BY_USER, headers);

            if (!response) {
                console.error("Failed to fetch site list.");
                this.setState({ site_list: [] });
                return;
            }

            this.setState({ site_list: response });
        } catch (error) {
            console.error("Error in getSitesList:", error);
            this.setState({ site_list: [] });
        }
    };

    handleDelete = async (site_id) => {
        // const userConfirmed = window.confirm('Are you sure you want to delete this site?');
        // if (!userConfirmed) return;

        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)


            const response = await fetch(urls.SITE_MANAGE_ID(site_id),
            { method: 'DELETE',
            headers : {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            });


            if (!response.ok) {
                // throw new Error(`Error: ${response.status}`);
                setTimeout(() => {
                    this.setState({error1 : true});
                    this.getSitesList()
                }, 1500); // 2 seconds delay
                return;
            }

            // this.setState((prevState) => ({
            //     site_list: prevState.site_list.filter((site) => site.site_id !== site_id),
            // }));
            setTimeout(() => {
                this.setState({success1 : true})
                this.getSitesList()
            }, 1000); // 2 seconds delay
            // alert(`Site with ID ${site_id} deleted successfully.`);
        } catch (error) {
            console.error('Error deleting site:', error);
            alert('Failed to delete site. Please try again.');
        }
    };

    handleChangePage = (newPage) => {
        this.setState({ currentPage: newPage });
    };

    handleSearchInputChange = (e) => {
        this.setState({ searchInput: e.target.value });
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    closePopup = () => {
        this.setState({ editToggle: false });
    };

    handleEdit = async (site_id) => {
        this.setState({ editToggle: true, siteid: site_id });
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.SITE_MANAGE_ID(site_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);

            const response = await get(url, headers); // Perform the API call using the constructed URL

            console.log(`API Response for LoadSelectedDeviceInfo ${site_id}:`, response);

            if (response && Object.keys(response).length > 0) {
                console.log(`API Response for LoadSelectedDeviceInfo ${site_id}:`, response);
                this.setState({
                    sitename: response.sitename || "",
                    organisation_name: response.organisation_name || "",
                    address: response.address || "",
                    // timezone: response.timezone || "",
                    selected_Customers: response.users || [],  // Populate selected_Customers with the users list from the response
                });

            } else {
                console.error("No valid data returned from the get-camera API");
                // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
            }
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            // this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }
    };

    handleEditSave = async () => {
        console.log("handle edit save");
        const { sitename, organisation_name, address, selected_Customers } = this.state;

        if (!sitename || !organisation_name || !address) {
            this.setState({ warning: true });
            return;
        }

        const loggedInUserId = localStorage.getItem(globalVariables.USER_ID);
        const userIds = selected_Customers.map(customer => customer.user_id);

        if (loggedInUserId) {
            userIds.push(loggedInUserId);
        }

        const data = JSON.stringify({
            sitename,
            address,
            organisation_name,
            users: userIds,
        });

        console.log("Data to be saved:", data);

        try {
            const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            const headers = {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_token}`,
            };

            console.log("API URL:", urls.SITE_UPDATE_CUSTOM(this.state.siteid));

            const response = await fetch(urls.SITE_UPDATE_CUSTOM(this.state.siteid), {
                method: 'POST',
                headers,
                body: data,
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                console.error("API Error Response:", errorResponse);
                throw new Error(`API Error: ${response.status} ${response.statusText}`);
            }

            const result = await response.json();
            console.log("Response from backend:", result);

            this.setState({ success: true });
            setTimeout(() => {
                this.getSitesList();
            }, 1500);
        } catch (error) {
            console.error("Error:", error);
            this.setState({ error: true });
        }
    };

    handleNavigatonToListDevice=(siteId, siteName)=>{
        localStorage.setItem(globalVariables.SITE_ID, siteId);
        localStorage.setItem(globalVariables.SITE_NAME, siteName);
        this.props.navigate("/system-manager/listDevices");
    }

    handleSetupNavigation=(siteId)=>{
        localStorage.setItem(globalVariables.SITE_ID, siteId);
        this.props.navigate("/system-manager/addDevice");
    }

    openDialog = (onConfirm) => {
        this.setState({
          confirmDialog: {
            isOpen: true,
            title: 'Confirm Action',
            subtitle: "Are you sure, you want to delete this site?",
            onConfirm
          },
        });
      };

    closeDialog = () => {
        this.setState({
          confirmDialog: {
            ...this.state.confirmDialog,
            isOpen: false,
          },
        });
      };
      generateColor = (index) => {
        const colors = ["#1E90FF", "#9370DB", "#6495ED", "#FFD700", "#FF69B4", "#20B2AA"];
        // Neutral and visually appealing colors
        return colors[index % colors.length];
    };



    render() {
        const { site_list, client_list, currentPage, rowsPerPage, searchInput,
             editToggle, sitename, address, organisation_name, timezone, error1, selected_Customers,
              timezone_list, error, success, confirmDialog, user_type, success1} = this.state;

        const filteredSiteList = (site_list || []).filter((site) =>
            site.sitename.toLowerCase().includes(searchInput.toLowerCase())
        );

        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = filteredSiteList.slice(indexOfFirstRow, indexOfLastRow);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height:'90vh'}}>
                <div className="home-container" style={{ display: 'flex', flex: '1', paddingLeft: '5px', overflowY: 'auto' }}>
                    <div style={{ flex: '4', marginLeft: '11%', padding: '20px' }}>
                        <div>
                        {error1 ? (
                            <Alert severity="error">Server Error! Site was not deleted!</Alert>
                        ) : success1 ? (
                            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                "The site deleted successfully."
                            </Alert>
                        ) : null}
                            <div style={{ marginTop: '2%' }}>
                                <table className="table-site">
                                    <thead>
                                    <tr>
                                    {user_type === "DealerUser" && (
                                        <th>Actions</th>
                                    )}
                                        <th>Site Name</th>
                                        <th>Organisation Name</th>
                                        <th>Address</th>
                                        <th>Timezone</th>
                                        <th>Clients</th>
                                        <th>Devices</th>
                                        <th>Cameras</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {currentRows.map((site) => (
                                        <tr key={site.site_id}>
                                            {/* Actions */}
                                            {user_type === "DealerUser" && (
                                                <td>
                                                    <span style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                        <Link>
                                                            <img
                                                            width="20"
                                                            height="20"
                                                            src={EditIcon}
                                                            alt="editIcon"
                                                            title="Edit site info"
                                                            onClick={() => this.handleEdit(site.id)}
                                                            />
                                                        </Link>
                                                        &ensp;
                                                        <Link>
                                                            <img
                                                            width="20"
                                                            height="18"
                                                            src={DeleteIcon}
                                                            alt="deleteIcon"
                                                            title="Delete site info"
                                                            onClick={() => this.openDialog(() => this.handleDelete(site.id))}
                                                            />
                                                        </Link>
                                                    </span>

                                                </td>
                                            )}
                                            <td>{site.sitename}</td>
                                            <td>{site.organisation_name}</td>
                                            <td>{site.address}</td>
                                            <td>{site.timezone}</td>
                                            {/* Clients */}
                                            <td>
                                                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                                {site.users
                                                    .filter(user => user.user_id !== localStorage.getItem(globalVariables.USER_ID)) // Exclude current user
                                                    .map((user, index) => (
                                                    <span
                                                        key={user.user_id}
                                                        style={{
                                                        color: this.generateColor(index),
                                                        //color: "#fff",
                                                        padding: "5px 10px",
                                                        borderRadius: "8px",
                                                        fontWeight: "bold",
                                                        fontSize: "0.9rem",
                                                        textTransform: "capitalize",
                                                        }}
                                                    >
                                                        {user.username}
                                                    </span>
                                                    ))}
                                                </div>
                                            </td>
                                            {/* Devices */}
                                            <td>
                                                {site.device_count === 0 ? (
                                                <Button
                                                    style={{ backgroundColor: '#f9d9bf' }}
                                                    onClick={() => this.handleSetupNavigation(site.id)}
                                                >
                                                    <b>Setup</b>
                                                </Button>
                                                ) : (
                                                <Button
                                                    style={{ backgroundColor: '#d9f9bf' }}
                                                    onClick={() => this.handleNavigatonToListDevice(site.id, site.sitename)}
                                                >
                                                    <b>{site.device_count} Device(s)</b>
                                                </Button>
                                                )}
                                            </td>
                                            {/* Cameras */}
                                            <td>
                                                {site.camera_count === 0 ? (
                                                    <Button style={{ backgroundColor: '#f9d9bf' }}>
                                                    <b>{site.camera_count} Camera</b>
                                                    </Button>
                                                    ):(
                                                    <Button style={{ backgroundColor: '#d9f9bf' }}>
                                                    <b>{site.camera_count} Camera(s)</b>
                                                    </Button>
                                                )}
                                            </td>

                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>

                            {editToggle && (
                                <>
                                    {/* Background Overlay */}
                                    <div style={{
                                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.3)", // Dim effect
                                        // backdropFilter: "blur(3px)", // Blur effect
                                        zIndex: 999, // Ensure it's below the popup
                                    }}
                                        onClick={this.closePopup} // Close the popup when clicking on the overlay
                                    />

                                    <div style={{
                                        // position: "fixed",
                                        // top: "5.75%",
                                        // left: "75.5%",
                                        // transform: "translate(-50%)",
                                        // // transform: editToggle ? 'translateX(75%)' : 'translateX(100%)', // Sliding effect
                                        // transition: 'transform 0.5s ease', // Smooth sliding transition
                                        // backgroundColor: "#f9f9f9",
                                        // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        // padding: "20px",
                                        // zIndex: 1000,
                                        // width: "60%",
                                        // height:'80%',
                                        // maxWidth: "680px",
                                        // borderRadius: "8px",
                                    }} className='Slide-left-edit-form' >

                                        <div className="form-section">
                                            <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#8195a6', height: '1cm', alignContent: 'center' }}>Edit Site Info</h3>

                                            {error ? (
                                                <Alert severity="error">Server Error! Site Info was not updated!</Alert>
                                            ) : success ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                                    "All set! The site info was updated successfully."
                                                </Alert>
                                            ) : null}

                                            <div className='form-group-device-edit'>
                                                <label htmlFor="sitename">
                                                    Site Name <span style={{ color: "red" }}> </span>: &nbsp;
                                                </label>
                                                <input
                                                    type="text"
                                                    name="sitename"
                                                    value={sitename || ""}
                                                    onChange={this.handleInputChange}
                                                    style={{ width: "350px", height: "0.7cm" }}
                                                />
                                            </div>
                                            <div className='form-group-device-edit'>
                                                <label htmlFor="address">
                                                    Address: &nbsp;
                                                </label>
                                                <input
                                                    type="text"
                                                    name="address"
                                                    value={address || ""}
                                                    onChange={this.handleInputChange}
                                                    style={{ width: "350px", height: "0.7cm" }}
                                                />


                                            </div>
                                            <div className='form-group-device-edit'>
                                                <label htmlFor="organisation_name">
                                                    Organisation Name: &nbsp;
                                                </label>
                                                <input
                                                    type="text"
                                                    name="organisation_name"
                                                    value={organisation_name || ""}
                                                    onChange={this.handleInputChange}
                                                    style={{ width: "350px", height: "0.7cm" }}
                                                />
                                            </div>

                                            <div className='form-group-device-edit'>
                                                <label htmlFor="customers">
                                                    Associated Customers: &nbsp;
                                                </label>
                                                <select
                                                    name='customers'
                                                    multiple
                                                    onChange={this.handleSelectionChange}
                                                    style={{ width: "365px", height: "1.5cm", color:'black' }}
                                                    value={this.state.selected_Customers.map(customer => customer.user_id)} // Set the selected customers
                                                >
                                                    {client_list.map((customer) => (
                                                        <option
                                                            key={customer.user_id}
                                                            value={customer.user_id}
                                                        >
                                                            {customer.username} - {customer.email}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>


                                            <div style={{ display: "flex", justifyContent: "right", gap: "5px", marginTop:'15px' }}>
                                                <Button
                                                    type="button"
                                                    onClick={this.handleEditSave}
                                                    style={{
                                                        width: "0.8cm",
                                                        height: "0.7cm",
                                                        backgroundColor: "#326388",
                                                        color: "white",
                                                    }}
                                                >
                                                    Save
                                                </Button>
                                                <Button
                                                    type="button"
                                                    onClick={this.closePopup}
                                                    style={{
                                                        width: "0.8cm",
                                                        height: "0.7cm",
                                                        backgroundColor: "#e02e2e",
                                                        color: "white",
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div style={{ marginTop: '2.2cm', display: 'flex', justifyContent: 'center', marginBottom: '2.2cm' }}>
                                <button onClick={() => this.handleChangePage(currentPage - 1)} disabled={currentPage === 1}>
                                    {"< Prev"}
                                </button>
                                &emsp;
                                <span style={{ fontSize: 'small' }}>
                                    {`Page ${currentPage} / ${Math.ceil(site_list.length / rowsPerPage)}`}
                                </span>
                                &emsp;
                                <button onClick={() => this.handleChangePage(currentPage + 1)} disabled={currentPage === Math.ceil(site_list.length / rowsPerPage)}>
                                    {"Next >"}
                                </button>
                            </div>
                        </div>
                        <DialogBox
                            confirmDialog={confirmDialog}
                            setConfirmDialog={(updatedDialog) =>
                                this.setState({ confirmDialog: updatedDialog })
                            }
                            onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
                            onCancel={this.closeDialog}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withNavigate(SiteView);